export const OLD_OFFICE_TOUR_JSON = [
  {
    id: 'reception',
    title: 'Reception',
    friendlyName: 'reception',
    type: 'Ground',
    panoType: 'Image360',
    isDefault: false,
    location: '',
    viewingAngle: null,
    defaultOrientation: [
      -65.79908561575311, 12.94251376666185, -500.00000000000006,
    ],
    coordinates: [0, 0, 0],
    lensFlareLocation: [],
    noLensFlare: true,
    showOnMap: false,
    yaw: 0,
    pitch: 0,
    roll: 0,
    elevation: null,
    previewImgUrl:
      'https://platform-resources-production.s3.ap-southeast-1.amazonaws.com/thumb/f73ccf6c-d259-45a0-8dd4-9875a04f37ab.jpg',
    tourGroupId: '67e61b695877d64d08c56203',
    hotspots: [
      {
        type: 'gift',
        location: [-500, -88.14424072354743, -96.3884934863617],
        _id: 'abc',
        media: {
          type: 'gift',
          _id: 'abc',
          imgUrl: '/assets/images/gift/1.png',
        },
      },
      {
        type: 'gift',
        location: [
          -313.07611451194674, -27.557296358372742, 499.99999999999994,
        ],
        _id: 'abc',
        media: {
          type: 'gift',
          _id: 'abc',
          imgUrl: '/assets/images/gift/2.png',
        },
      },
      {
        type: 'gift',
        location: [-500, -86.21151884306745, 292.7615131266581],
        _id: 'abc',
        media: {
          type: 'gift',
          _id: 'abc',
          imgUrl: '/assets/images/gift/3.png',
        },
      },
    ],
    mediaLogoOverride: null,
    variantTitle: null,
    variantOrder: 0,
    sceneVariants: null,
    sourceImgId: '67e61b8d5877d64d08c56215',
    steps: [
      {
        id: '67e6225e5877d64d08c5646b',
        updatedAt: '2025-03-28T04:15:26.348Z',
        isDeleted: false,
        deletedAt: null,
        sceneId: '67e61b8e5877d64d08c5621b',
        targetSceneId: '67e61b915877d64d08c56226',
        stepPosition: [-223.1554146022964, -152.1413953557031, 500],
        cameraPosition: [-223.15541460229645, 44.584597792216364, 500],
        cameraRotation: [
          4.062167192372682, -0.8115872552742847, -9.101655004903634,
        ],
        targetSceneCameraPosition: [
          -75.03316860626474, -17.12275878441455, 499.99999999999994,
        ],
        targetSceneCameraRotation: [
          1.4831958020577518, 0.33846903203513007, -9.883601010113248,
        ],
        tourId: '67e61b695877d64d08c56201',
        createdAt: '2025-03-28T04:15:26.348Z',
        v: 0,
      },
      {
        id: '67e6225e5877d64d08c5646d',
        updatedAt: '2025-03-28T04:15:26.352Z',
        isDeleted: false,
        deletedAt: null,
        sceneId: '67e61b8e5877d64d08c5621b',
        targetSceneId: '67e61ba55877d64d08c56269',
        stepPosition: [
          430.5654632622758, -251.87387362530046, -499.99999999999994,
        ],
        cameraPosition: [430.5654632622769, -8.935646356615987, -500],
        cameraRotation: [
          -6.52471931499264, 0.13540933806723174, 7.57691904217843,
        ],
        targetSceneCameraPosition: [
          -6.770842849049284, -47.54157856194844, 500.00000000000006,
        ],
        targetSceneCameraRotation: [
          0.13479658978756098, 0.9464763554758758, -9.954195717781872,
        ],
        tourId: '67e61b695877d64d08c56201',
        createdAt: '2025-03-28T04:15:26.352Z',
        v: 0,
      },
    ],
    configuration: '',
    cubeMapImages: {
      size4096: [
        'https://platform-resources-production.s3.ap-southeast-1.amazonaws.com/4096-px/67e61b8d5877d64d08c56215.jpg',
        'https://platform-resources-production.s3.ap-southeast-1.amazonaws.com/4096-nx/67e61b8d5877d64d08c56215.jpg',
        'https://platform-resources-production.s3.ap-southeast-1.amazonaws.com/4096-py/67e61b8d5877d64d08c56215.jpg',
        'https://platform-resources-production.s3.ap-southeast-1.amazonaws.com/4096-ny/67e61b8d5877d64d08c56215.jpg',
        'https://platform-resources-production.s3.ap-southeast-1.amazonaws.com/4096-pz/67e61b8d5877d64d08c56215.jpg',
        'https://platform-resources-production.s3.ap-southeast-1.amazonaws.com/4096-nz/67e61b8d5877d64d08c56215.jpg',
      ],
      size2048: [
        'https://platform-resources-production.s3.ap-southeast-1.amazonaws.com/2048-px/67e61b8d5877d64d08c56215.jpg',
        'https://platform-resources-production.s3.ap-southeast-1.amazonaws.com/2048-nx/67e61b8d5877d64d08c56215.jpg',
        'https://platform-resources-production.s3.ap-southeast-1.amazonaws.com/2048-py/67e61b8d5877d64d08c56215.jpg',
        'https://platform-resources-production.s3.ap-southeast-1.amazonaws.com/2048-ny/67e61b8d5877d64d08c56215.jpg',
        'https://platform-resources-production.s3.ap-southeast-1.amazonaws.com/2048-pz/67e61b8d5877d64d08c56215.jpg',
        'https://platform-resources-production.s3.ap-southeast-1.amazonaws.com/2048-nz/67e61b8d5877d64d08c56215.jpg',
      ],
      size1024: [
        'https://platform-resources-production.s3.ap-southeast-1.amazonaws.com/1024-px/67e61b8d5877d64d08c56215.jpg',
        'https://platform-resources-production.s3.ap-southeast-1.amazonaws.com/1024-nx/67e61b8d5877d64d08c56215.jpg',
        'https://platform-resources-production.s3.ap-southeast-1.amazonaws.com/1024-py/67e61b8d5877d64d08c56215.jpg',
        'https://platform-resources-production.s3.ap-southeast-1.amazonaws.com/1024-ny/67e61b8d5877d64d08c56215.jpg',
        'https://platform-resources-production.s3.ap-southeast-1.amazonaws.com/1024-pz/67e61b8d5877d64d08c56215.jpg',
        'https://platform-resources-production.s3.ap-southeast-1.amazonaws.com/1024-nz/67e61b8d5877d64d08c56215.jpg',
      ],
    },
    sphericalImages: {
      resize4096:
        'https://platform-resources-production.s3.ap-southeast-1.amazonaws.com/eq-4096/67e61b8d5877d64d08c56215.jpg',
      resize2048:
        'https://platform-resources-production.s3.ap-southeast-1.amazonaws.com/eq-2048/67e61b8d5877d64d08c56215.jpg',
    },
    sceneType: 'GROUND',
    _id: '67e61b8e5877d64d08c5621b',
    groupId: 'welcome',
  },
  {
    id: 'fluidmedia-team',
    title: 'Fluidmedia Team',
    friendlyName: 'fluidmedia-team',
    type: 'Ground',
    panoType: 'Image360',
    isDefault: false,
    location: '',
    viewingAngle: null,
    defaultOrientation: [
      53.68528736196952, -106.78241254648758, 499.99999999999994,
    ],
    coordinates: [0, 0, 0],
    lensFlareLocation: [],
    noLensFlare: true,
    showOnMap: false,
    yaw: 0,
    pitch: 0,
    roll: 0,
    elevation: null,
    previewImgUrl:
      'https://platform-resources-production.s3.ap-southeast-1.amazonaws.com/thumb/6f6a68da-90c9-45d8-baa5-eebfbca402fb.jpg',
    tourGroupId: '67e61b695877d64d08c56203',
    hotspots: [
      {
        id: 'fluidmedia-7b9d47c5',
        type: 'Media',
        distance: '0',
        location: [-35.56892775302813, -62.71896822001314, 500],
        mediaLinkId: '67e625785877d64d08c566ef',
        tourLinkedId: null,
        sceneLinkId: null,
        sceneVariantId: null,
        icon: null,
        iconUrl: null,
        iconActiveUrl: null,
        polygon: [],
        configs: '{"infoTagLine":""}',
        media: {
          id: 'fluidmedia-7b9d47c5',
          friendlyName: 'fluidmedia-7b9d47c5',
          imageUrl: null,
          readMoreUrl: null,
          text: null,
          title: 'Fluidmedia',
          type: 'InfoTag',
          youtubeId: null,
          soundUrl: null,
          customData: null,
          infoTag: {
            text: 'Đây là khu vực của team Fluidmedia. Fluidmedia chuyên cung cấp giải pháp công nghệ cho các ngành sản xuất, thương mại điện tử và chăm sóc sức khỏe, giúp tối ưu hóa quy trình và nâng cao hiệu quả doanh nghiệp.',
            readMoreUrl: '',
          },
          fileUrl: null,
          configs: [],
          gallery: [],
          matterport: null,
          google360: null,
          mapFloorPlan: [],
          _id: '67e625785877d64d08c566ef',
        },
        _id: '67e625785877d64d08c566ef',
        friendlyName: 'fluidmedia-7b9d47c5',
      },
      {
        media: {
          type: 'gift',
          _id: 'abc',
          imgUrl: '/assets/images/gift/2.png',
        },
        type: 'gift',
        location: [
          -347.03895358173725, -24.910175945028257, 500.00000000000006,
        ],
        _id: 'abc',
      },
      {
        media: {
          type: 'gift',
          _id: 'abc',
          imgUrl: '/assets/images/gift/3.png',
        },
        type: 'gift',
        location: [-500, -50.896175403033816, 56.90548206330043],
        _id: '123',
      },
    ],
    mediaLogoOverride: null,
    variantTitle: null,
    variantOrder: 0,
    sceneVariants: null,
    sourceImgId: '67e61b905877d64d08c56220',
    steps: [
      {
        id: '67e6225e5877d64d08c5646f',
        updatedAt: '2025-03-28T04:15:26.400Z',
        isDeleted: false,
        deletedAt: null,
        sceneId: '67e61b915877d64d08c56226',
        targetSceneId: '67e61b8e5877d64d08c5621b',
        stepPosition: [75.03316861581472, -205.68907125192268, -500],
        cameraPosition: [
          75.03316860626474, -17.12275878441455, -499.99999999999994,
        ],
        cameraRotation: [
          -1.4831958020577518, 0.33846903203513007, 9.883601010113248,
        ],
        targetSceneCameraPosition: [
          223.15541460229645, 44.584597792216364, -500,
        ],
        targetSceneCameraRotation: [
          -4.062167192372682, -0.8115872552742847, 9.101655004903634,
        ],
        tourId: '67e61b695877d64d08c56201',
        createdAt: '2025-03-28T04:15:26.400Z',
        v: 0,
      },
      {
        id: '67e622a25877d64d08c564cb',
        updatedAt: '2025-03-28T04:16:34.326Z',
        isDeleted: false,
        deletedAt: null,
        sceneId: '67e61b915877d64d08c56226',
        targetSceneId: '67e61b945877d64d08c56231',
        stepPosition: [
          -499.99999999999994, -132.64704593945785, 50.95536635988511,
        ],
        cameraPosition: [-500, 47.78339463953381, 50.955366359885105],
        cameraRotation: [
          9.903811797752086, -0.946475495135317, -1.009304717027621,
        ],
        targetSceneCameraPosition: [
          -500.00000000000006, 16.93470640968353, 6.771086827158513,
        ],
        targetSceneCameraRotation: [
          9.993353993326528, -0.33846903185004723, -0.13533173516668964,
        ],
        tourId: '67e61b695877d64d08c56201',
        createdAt: '2025-03-28T04:16:34.326Z',
        v: 0,
      },
    ],
    configuration: '',
    cubeMapImages: {
      size4096: [
        'https://platform-resources-production.s3.ap-southeast-1.amazonaws.com/4096-px/67e61b905877d64d08c56220.jpg',
        'https://platform-resources-production.s3.ap-southeast-1.amazonaws.com/4096-nx/67e61b905877d64d08c56220.jpg',
        'https://platform-resources-production.s3.ap-southeast-1.amazonaws.com/4096-py/67e61b905877d64d08c56220.jpg',
        'https://platform-resources-production.s3.ap-southeast-1.amazonaws.com/4096-ny/67e61b905877d64d08c56220.jpg',
        'https://platform-resources-production.s3.ap-southeast-1.amazonaws.com/4096-pz/67e61b905877d64d08c56220.jpg',
        'https://platform-resources-production.s3.ap-southeast-1.amazonaws.com/4096-nz/67e61b905877d64d08c56220.jpg',
      ],
      size2048: [
        'https://platform-resources-production.s3.ap-southeast-1.amazonaws.com/2048-px/67e61b905877d64d08c56220.jpg',
        'https://platform-resources-production.s3.ap-southeast-1.amazonaws.com/2048-nx/67e61b905877d64d08c56220.jpg',
        'https://platform-resources-production.s3.ap-southeast-1.amazonaws.com/2048-py/67e61b905877d64d08c56220.jpg',
        'https://platform-resources-production.s3.ap-southeast-1.amazonaws.com/2048-ny/67e61b905877d64d08c56220.jpg',
        'https://platform-resources-production.s3.ap-southeast-1.amazonaws.com/2048-pz/67e61b905877d64d08c56220.jpg',
        'https://platform-resources-production.s3.ap-southeast-1.amazonaws.com/2048-nz/67e61b905877d64d08c56220.jpg',
      ],
      size1024: [
        'https://platform-resources-production.s3.ap-southeast-1.amazonaws.com/1024-px/67e61b905877d64d08c56220.jpg',
        'https://platform-resources-production.s3.ap-southeast-1.amazonaws.com/1024-nx/67e61b905877d64d08c56220.jpg',
        'https://platform-resources-production.s3.ap-southeast-1.amazonaws.com/1024-py/67e61b905877d64d08c56220.jpg',
        'https://platform-resources-production.s3.ap-southeast-1.amazonaws.com/1024-ny/67e61b905877d64d08c56220.jpg',
        'https://platform-resources-production.s3.ap-southeast-1.amazonaws.com/1024-pz/67e61b905877d64d08c56220.jpg',
        'https://platform-resources-production.s3.ap-southeast-1.amazonaws.com/1024-nz/67e61b905877d64d08c56220.jpg',
      ],
    },
    sphericalImages: {
      resize4096:
        'https://platform-resources-production.s3.ap-southeast-1.amazonaws.com/eq-4096/67e61b905877d64d08c56220.jpg',
      resize2048:
        'https://platform-resources-production.s3.ap-southeast-1.amazonaws.com/eq-2048/67e61b905877d64d08c56220.jpg',
    },
    sceneType: 'GROUND',
    _id: '67e61b915877d64d08c56226',
    groupId: 'welcome',
  },
  {
    id: 'zaiten-team',
    title: 'Zaiten Team',
    friendlyName: 'zaiten-team',
    type: 'Ground',
    panoType: 'Image360',
    isDefault: false,
    location: '',
    viewingAngle: null,
    defaultOrientation: [
      -430.66885434487716, -151.2606795914465, 499.99999999999994,
    ],
    coordinates: [0, 0, 0],
    lensFlareLocation: [],
    noLensFlare: true,
    showOnMap: false,
    yaw: 0,
    pitch: 0,
    roll: 0,
    elevation: null,
    previewImgUrl:
      'https://platform-resources-production.s3.ap-southeast-1.amazonaws.com/thumb/10dc7895-7ff8-4a98-bdbb-d669dd7ea297.jpg',
    tourGroupId: '67e61b695877d64d08c56203',
    hotspots: [
      {
        id: 'zaiten-913a758e',
        type: 'Media',
        distance: '0',
        location: [-409.94435570903835, -12.1931799623125, 499.99999999999994],
        mediaLinkId: '67e63c1b5877d64d08c568f9',
        tourLinkedId: null,
        sceneLinkId: null,
        sceneVariantId: null,
        icon: null,
        iconUrl: null,
        iconActiveUrl: null,
        polygon: [],
        configs: '',
        media: {
          id: 'zaiten-913a758e',
          friendlyName: 'zaiten-913a758e',
          imageUrl: null,
          readMoreUrl: null,
          text: null,
          title: 'Zaiten',
          type: 'InfoTag',
          youtubeId: null,
          soundUrl: null,
          customData: null,
          infoTag: {
            text: 'Đây là khu vực của team Zaiten. Zaiten cung cấp các giải pháp công nghệ trong lĩnh vực ngân hàng và tài chính; giúp tối ưu hóa quy trình tài chính, tăng cường bảo mật và nâng cao trải nghiệm người dùn',
            readMoreUrl: '',
          },
          fileUrl: null,
          configs: [],
          gallery: [],
          matterport: null,
          google360: null,
          mapFloorPlan: [],
          _id: '67e63c1b5877d64d08c568f9',
        },
        _id: '67e63c1b5877d64d08c568f9',
        friendlyName: 'zaiten-913a758e',
      },
      {
        media: {
          type: 'gift',
          _id: 'abc',
          imgUrl: '/assets/images/gift/1.png',
        },
        type: 'gift',
        location: [59.59358795447, -81.34883118661108, -500.00000000000006],
        _id: 'abc',
      },
      {
        media: {
          type: 'gift',
          _id: '123',
          imgUrl: '/assets/images/gift/2.png',
        },
        type: 'gift',
        location: [500, -64.44491710077645, 120.02040346381133],
        _id: '123',
      },
    ],
    mediaLogoOverride: null,
    variantTitle: null,
    variantOrder: 0,
    sceneVariants: null,
    sourceImgId: '67e61b935877d64d08c5622b',
    steps: [
      {
        id: '67e622a25877d64d08c564cd',
        updatedAt: '2025-03-28T04:16:34.333Z',
        isDeleted: false,
        deletedAt: null,
        sceneId: '67e61b945877d64d08c56231',
        targetSceneId: '67e61b915877d64d08c56226',
        stepPosition: [500, -165.09674695788064, -6.771086781503083],
        cameraPosition: [
          500.00000000000006, 16.93470640968353, -6.771086827158513,
        ],
        cameraRotation: [
          -9.993353993326528, -0.33846903185004723, 0.13533173516668964,
        ],
        targetSceneCameraPosition: [
          500, 47.78339463953381, -50.955366359885105,
        ],
        targetSceneCameraRotation: [
          -9.903811797752086, -0.946475495135317, 1.009304717027621,
        ],
        tourId: '67e61b695877d64d08c56201',
        createdAt: '2025-03-28T04:16:34.333Z',
        v: 0,
      },
      {
        id: '67e622d15877d64d08c56505',
        updatedAt: '2025-03-28T04:17:21.604Z',
        isDeleted: false,
        deletedAt: null,
        sceneId: '67e61b945877d64d08c56231',
        targetSceneId: '67e61b975877d64d08c5623c',
        stepPosition: [-75.03316753800262, -111.70562033708387, -500],
        cameraPosition: [
          -75.03316753800259, 68.88655690255523, -499.9999999999999,
        ],
        cameraRotation: [
          1.47046049264979, -1.35000245522856, 9.798736618076513,
        ],
        targetSceneCameraPosition: [
          30.505799814238152, 13.569845358341386, -499.99999999999994,
        ],
        targetSceneCameraRotation: [
          -0.6087602814973547, -0.27079384676103035, 9.977779392842258,
        ],
        tourId: '67e61b695877d64d08c56201',
        createdAt: '2025-03-28T04:17:21.604Z',
        v: 0,
      },
    ],
    configuration: '',
    cubeMapImages: {
      size4096: [
        'https://platform-resources-production.s3.ap-southeast-1.amazonaws.com/4096-px/67e61b935877d64d08c5622b.jpg',
        'https://platform-resources-production.s3.ap-southeast-1.amazonaws.com/4096-nx/67e61b935877d64d08c5622b.jpg',
        'https://platform-resources-production.s3.ap-southeast-1.amazonaws.com/4096-py/67e61b935877d64d08c5622b.jpg',
        'https://platform-resources-production.s3.ap-southeast-1.amazonaws.com/4096-ny/67e61b935877d64d08c5622b.jpg',
        'https://platform-resources-production.s3.ap-southeast-1.amazonaws.com/4096-pz/67e61b935877d64d08c5622b.jpg',
        'https://platform-resources-production.s3.ap-southeast-1.amazonaws.com/4096-nz/67e61b935877d64d08c5622b.jpg',
      ],
      size2048: [
        'https://platform-resources-production.s3.ap-southeast-1.amazonaws.com/2048-px/67e61b935877d64d08c5622b.jpg',
        'https://platform-resources-production.s3.ap-southeast-1.amazonaws.com/2048-nx/67e61b935877d64d08c5622b.jpg',
        'https://platform-resources-production.s3.ap-southeast-1.amazonaws.com/2048-py/67e61b935877d64d08c5622b.jpg',
        'https://platform-resources-production.s3.ap-southeast-1.amazonaws.com/2048-ny/67e61b935877d64d08c5622b.jpg',
        'https://platform-resources-production.s3.ap-southeast-1.amazonaws.com/2048-pz/67e61b935877d64d08c5622b.jpg',
        'https://platform-resources-production.s3.ap-southeast-1.amazonaws.com/2048-nz/67e61b935877d64d08c5622b.jpg',
      ],
      size1024: [
        'https://platform-resources-production.s3.ap-southeast-1.amazonaws.com/1024-px/67e61b935877d64d08c5622b.jpg',
        'https://platform-resources-production.s3.ap-southeast-1.amazonaws.com/1024-nx/67e61b935877d64d08c5622b.jpg',
        'https://platform-resources-production.s3.ap-southeast-1.amazonaws.com/1024-py/67e61b935877d64d08c5622b.jpg',
        'https://platform-resources-production.s3.ap-southeast-1.amazonaws.com/1024-ny/67e61b935877d64d08c5622b.jpg',
        'https://platform-resources-production.s3.ap-southeast-1.amazonaws.com/1024-pz/67e61b935877d64d08c5622b.jpg',
        'https://platform-resources-production.s3.ap-southeast-1.amazonaws.com/1024-nz/67e61b935877d64d08c5622b.jpg',
      ],
    },
    sphericalImages: {
      resize4096:
        'https://platform-resources-production.s3.ap-southeast-1.amazonaws.com/eq-4096/67e61b935877d64d08c5622b.jpg',
      resize2048:
        'https://platform-resources-production.s3.ap-southeast-1.amazonaws.com/eq-2048/67e61b935877d64d08c5622b.jpg',
    },
    sceneType: 'GROUND',
    _id: '67e61b945877d64d08c56231',
    groupId: 'welcome',
  },
  {
    id: 'left-passage',
    title: 'Left Passage',
    friendlyName: 'left-passage',
    type: 'Ground',
    panoType: 'Image360',
    isDefault: false,
    location: '',
    viewingAngle: null,
    defaultOrientation: [
      47.980241167424225, -1.345706222187835, -499.99999999999994,
    ],
    coordinates: [0, 0, 0],
    lensFlareLocation: [],
    noLensFlare: true,
    showOnMap: false,
    yaw: 0,
    pitch: 0,
    roll: 0,
    elevation: null,
    previewImgUrl:
      'https://platform-resources-production.s3.ap-southeast-1.amazonaws.com/thumb/835fdb8b-e522-492a-83ec-4d120baa5539.jpg',
    tourGroupId: '67e61b695877d64d08c56203',
    hotspots: [
      {
        media: {
          type: 'gift',
          _id: 'abc',
          imgUrl: '/assets/images/gift/1.png',
        },
        type: 'gift',
        location: [34.68377886821213, -76.27699246921819, -499.99999999999994],
        _id: 'abc',
      },
      {
        media: {
          type: 'gift',
          _id: '123',
          imgUrl: '/assets/images/gift/2.png',
        },
        type: 'gift',
        location: [-50.53604593663171, -12.338923349505285, 500],
        _id: '123',
      },
    ],
    mediaLogoOverride: null,
    variantTitle: null,
    variantOrder: 0,
    sceneVariants: null,
    sourceImgId: '67e61b965877d64d08c56236',
    steps: [
      {
        id: '67e622d15877d64d08c56507',
        updatedAt: '2025-03-28T04:17:21.610Z',
        isDeleted: false,
        deletedAt: null,
        sceneId: '67e61b975877d64d08c5623c',
        targetSceneId: '67e61b945877d64d08c56231',
        stepPosition: [
          -30.505799814238227, -169.14398238842736, 499.99999999999994,
        ],
        cameraPosition: [
          -30.505799814238152, 13.569845358341386, 499.99999999999994,
        ],
        cameraRotation: [
          0.6087602814973547, -0.27079384676103035, -9.977779392842258,
        ],
        targetSceneCameraPosition: [
          75.03316753800259, 68.88655690255523, 499.9999999999999,
        ],
        targetSceneCameraRotation: [
          -1.47046049264979, -1.35000245522856, -9.798736618076513,
        ],
        tourId: '67e61b695877d64d08c56201',
        createdAt: '2025-03-28T04:17:21.610Z',
        v: 0,
      },
      {
        id: '67e6231c5877d64d08c56542',
        updatedAt: '2025-03-28T04:18:36.814Z',
        isDeleted: false,
        deletedAt: null,
        sceneId: '67e61b975877d64d08c5623c',
        targetSceneId: '67e61b9b5877d64d08c56247',
        stepPosition: [54.378185419597884, -232.90327116755023, -500],
        cameraPosition: [54.37818999870065, -40.95375766933282, -500],
        cameraRotation: [
          -1.0776218359323364, 0.8115875782001774, 9.90858500400703,
        ],
        targetSceneCameraPosition: [
          -396.3686153482741, 12.961872346388592, 500,
        ],
        targetSceneCameraRotation: [
          6.210903799744282, -0.20310624779726433, -7.8347572931411085,
        ],
        tourId: '67e61b695877d64d08c56201',
        createdAt: '2025-03-28T04:18:36.814Z',
        v: 0,
      },
    ],
    configuration: '',
    cubeMapImages: {
      size4096: [
        'https://platform-resources-production.s3.ap-southeast-1.amazonaws.com/4096-px/67e61b965877d64d08c56236.jpg',
        'https://platform-resources-production.s3.ap-southeast-1.amazonaws.com/4096-nx/67e61b965877d64d08c56236.jpg',
        'https://platform-resources-production.s3.ap-southeast-1.amazonaws.com/4096-py/67e61b965877d64d08c56236.jpg',
        'https://platform-resources-production.s3.ap-southeast-1.amazonaws.com/4096-ny/67e61b965877d64d08c56236.jpg',
        'https://platform-resources-production.s3.ap-southeast-1.amazonaws.com/4096-pz/67e61b965877d64d08c56236.jpg',
        'https://platform-resources-production.s3.ap-southeast-1.amazonaws.com/4096-nz/67e61b965877d64d08c56236.jpg',
      ],
      size2048: [
        'https://platform-resources-production.s3.ap-southeast-1.amazonaws.com/2048-px/67e61b965877d64d08c56236.jpg',
        'https://platform-resources-production.s3.ap-southeast-1.amazonaws.com/2048-nx/67e61b965877d64d08c56236.jpg',
        'https://platform-resources-production.s3.ap-southeast-1.amazonaws.com/2048-py/67e61b965877d64d08c56236.jpg',
        'https://platform-resources-production.s3.ap-southeast-1.amazonaws.com/2048-ny/67e61b965877d64d08c56236.jpg',
        'https://platform-resources-production.s3.ap-southeast-1.amazonaws.com/2048-pz/67e61b965877d64d08c56236.jpg',
        'https://platform-resources-production.s3.ap-southeast-1.amazonaws.com/2048-nz/67e61b965877d64d08c56236.jpg',
      ],
      size1024: [
        'https://platform-resources-production.s3.ap-southeast-1.amazonaws.com/1024-px/67e61b965877d64d08c56236.jpg',
        'https://platform-resources-production.s3.ap-southeast-1.amazonaws.com/1024-nx/67e61b965877d64d08c56236.jpg',
        'https://platform-resources-production.s3.ap-southeast-1.amazonaws.com/1024-py/67e61b965877d64d08c56236.jpg',
        'https://platform-resources-production.s3.ap-southeast-1.amazonaws.com/1024-ny/67e61b965877d64d08c56236.jpg',
        'https://platform-resources-production.s3.ap-southeast-1.amazonaws.com/1024-pz/67e61b965877d64d08c56236.jpg',
        'https://platform-resources-production.s3.ap-southeast-1.amazonaws.com/1024-nz/67e61b965877d64d08c56236.jpg',
      ],
    },
    sphericalImages: {
      resize4096:
        'https://platform-resources-production.s3.ap-southeast-1.amazonaws.com/eq-4096/67e61b965877d64d08c56236.jpg',
      resize2048:
        'https://platform-resources-production.s3.ap-southeast-1.amazonaws.com/eq-2048/67e61b965877d64d08c56236.jpg',
    },
    sceneType: 'GROUND',
    _id: '67e61b975877d64d08c5623c',
    groupId: 'welcome',
  },
  {
    id: 'vizion-team',
    title: 'Vizion Team',
    friendlyName: 'vizion-team',
    type: 'Ground',
    panoType: 'Image360',
    isDefault: false,
    location: '',
    viewingAngle: null,
    defaultOrientation: [-500, -3.559005457529383, 177.68673455685376],
    coordinates: [0, 0, 0],
    lensFlareLocation: [],
    noLensFlare: true,
    showOnMap: false,
    yaw: 0,
    pitch: 0,
    roll: 0,
    elevation: null,
    previewImgUrl:
      'https://platform-resources-production.s3.ap-southeast-1.amazonaws.com/thumb/10038c14-f69f-4e62-9658-033609b27fd2.jpg',
    tourGroupId: '67e61b695877d64d08c56203',
    hotspots: [
      {
        id: 'vizion-a02c3569',
        type: 'Media',
        distance: '0',
        location: [-500.00000000000006, 32.6450977166026, 159.64913365094984],
        mediaLinkId: '67e63cd75877d64d08c56963',
        tourLinkedId: null,
        sceneLinkId: null,
        sceneVariantId: null,
        icon: null,
        iconUrl: null,
        iconActiveUrl: null,
        polygon: [],
        configs: '',
        media: {
          id: 'vizion-a02c3569',
          friendlyName: 'vizion-a02c3569',
          imageUrl: null,
          readMoreUrl: null,
          text: null,
          title: 'Vizion',
          type: 'InfoTag',
          youtubeId: null,
          soundUrl: null,
          customData: null,
          infoTag: {
            text: 'Đây là khu vực của team Vizion. Vizon chuyên cung cấp các giải pháp ảo hóa và trí tuệ nhân tạo, giúp tối ưu hóa quy trình và nâng cao hiệu suất cho doanh nghiệp.',
            readMoreUrl: '',
          },
          fileUrl: null,
          configs: [],
          gallery: [],
          matterport: null,
          google360: null,
          mapFloorPlan: [],
          _id: '67e63cd75877d64d08c56963',
        },
        _id: '67e63cd75877d64d08c56963',
        friendlyName: 'vizion-a02c3569',
      },
      {
        media: {
          type: 'gift',
          _id: 'abc',
          imgUrl: '/assets/images/gift/3.png',
        },
        type: 'gift',
        location: [-500, -41.133745190508876, -277.1901324542892],
        _id: 'abc',
      },
      {
        media: {
          type: 'gift',
          _id: 'abc',
          imgUrl: '/assets/images/gift/2.png',
        },
        type: 'gift',
        location: [500, -158.8591032587898, -497.52368753464924],
        _id: 'abc',
      },
    ],
    mediaLogoOverride: null,
    variantTitle: null,
    variantOrder: 0,
    sceneVariants: null,
    sourceImgId: '67e61b9a5877d64d08c56241',
    steps: [
      {
        id: '67e6231c5877d64d08c5653c',
        updatedAt: '2025-03-28T04:18:36.749Z',
        isDeleted: false,
        deletedAt: null,
        sceneId: '67e61b9b5877d64d08c56247',
        targetSceneId: '67e61b9e5877d64d08c56252',
        stepPosition: [-359.1495763235866, -188.68708597478042, 500],
        cameraPosition: [
          -359.1495763235874, 33.37796563890552, 500.00000000000006,
        ],
        cameraRotation: [
          5.825389806984417, -0.541389085854219, -8.109977278291224,
        ],
        targetSceneCameraPosition: [-500, 16.93656189277973, 10.15740750804259],
        targetSceneCameraRotation: [
          9.992208713968552, -0.33846732265940144, -0.20298987162638293,
        ],
        tourId: '67e61b695877d64d08c56201',
        createdAt: '2025-03-28T04:18:36.749Z',
        v: 0,
      },
      {
        id: '67e6231c5877d64d08c5653e',
        updatedAt: '2025-03-28T04:18:36.750Z',
        isDeleted: false,
        deletedAt: null,
        sceneId: '67e61b9b5877d64d08c56247',
        targetSceneId: '67e61ba25877d64d08c5625e',
        stepPosition: [
          -500.0000000000001, -176.70999903965546, -396.3686153482859,
        ],
        cameraPosition: [
          -500.0000000000001, 51.95473123251865, -396.3686153482852,
        ],
        cameraRotation: [
          7.810523084434038, -0.8115872552743058, 6.191692440245879,
        ],
        targetSceneCameraPosition: [
          500, -17.198957378322962, 88.93938388178286,
        ],
        targetSceneCameraRotation: [
          -9.839812527767217, 0.3384690325515135, -1.7502937274637302,
        ],
        tourId: '67e61b695877d64d08c56201',
        createdAt: '2025-03-28T04:18:36.750Z',
        v: 0,
      },
      {
        id: '67e6231c5877d64d08c5653a',
        updatedAt: '2025-03-28T04:18:36.745Z',
        isDeleted: false,
        deletedAt: null,
        sceneId: '67e61b9b5877d64d08c56247',
        targetSceneId: '67e61b975877d64d08c5623c',
        stepPosition: [396.36861534827455, -219.27645053012225, -500],
        cameraPosition: [396.3686153482741, 12.961872346388592, -500],
        cameraRotation: [
          -6.210903799744282, -0.20310624779726433, 7.8347572931411085,
        ],
        targetSceneCameraPosition: [
          -54.37818999870065, -40.95375766933282, 500,
        ],
        targetSceneCameraRotation: [
          1.0776218359323364, 0.8115875782001774, -9.90858500400703,
        ],
        tourId: '67e61b695877d64d08c56201',
        createdAt: '2025-03-28T04:18:36.745Z',
        v: 0,
      },
    ],
    configuration: '',
    cubeMapImages: {
      size4096: [
        'https://platform-resources-production.s3.ap-southeast-1.amazonaws.com/4096-px/67e61b9a5877d64d08c56241.jpg',
        'https://platform-resources-production.s3.ap-southeast-1.amazonaws.com/4096-nx/67e61b9a5877d64d08c56241.jpg',
        'https://platform-resources-production.s3.ap-southeast-1.amazonaws.com/4096-py/67e61b9a5877d64d08c56241.jpg',
        'https://platform-resources-production.s3.ap-southeast-1.amazonaws.com/4096-ny/67e61b9a5877d64d08c56241.jpg',
        'https://platform-resources-production.s3.ap-southeast-1.amazonaws.com/4096-pz/67e61b9a5877d64d08c56241.jpg',
        'https://platform-resources-production.s3.ap-southeast-1.amazonaws.com/4096-nz/67e61b9a5877d64d08c56241.jpg',
      ],
      size2048: [
        'https://platform-resources-production.s3.ap-southeast-1.amazonaws.com/2048-px/67e61b9a5877d64d08c56241.jpg',
        'https://platform-resources-production.s3.ap-southeast-1.amazonaws.com/2048-nx/67e61b9a5877d64d08c56241.jpg',
        'https://platform-resources-production.s3.ap-southeast-1.amazonaws.com/2048-py/67e61b9a5877d64d08c56241.jpg',
        'https://platform-resources-production.s3.ap-southeast-1.amazonaws.com/2048-ny/67e61b9a5877d64d08c56241.jpg',
        'https://platform-resources-production.s3.ap-southeast-1.amazonaws.com/2048-pz/67e61b9a5877d64d08c56241.jpg',
        'https://platform-resources-production.s3.ap-southeast-1.amazonaws.com/2048-nz/67e61b9a5877d64d08c56241.jpg',
      ],
      size1024: [
        'https://platform-resources-production.s3.ap-southeast-1.amazonaws.com/1024-px/67e61b9a5877d64d08c56241.jpg',
        'https://platform-resources-production.s3.ap-southeast-1.amazonaws.com/1024-nx/67e61b9a5877d64d08c56241.jpg',
        'https://platform-resources-production.s3.ap-southeast-1.amazonaws.com/1024-py/67e61b9a5877d64d08c56241.jpg',
        'https://platform-resources-production.s3.ap-southeast-1.amazonaws.com/1024-ny/67e61b9a5877d64d08c56241.jpg',
        'https://platform-resources-production.s3.ap-southeast-1.amazonaws.com/1024-pz/67e61b9a5877d64d08c56241.jpg',
        'https://platform-resources-production.s3.ap-southeast-1.amazonaws.com/1024-nz/67e61b9a5877d64d08c56241.jpg',
      ],
    },
    sphericalImages: {
      resize4096:
        'https://platform-resources-production.s3.ap-southeast-1.amazonaws.com/eq-4096/67e61b9a5877d64d08c56241.jpg',
      resize2048:
        'https://platform-resources-production.s3.ap-southeast-1.amazonaws.com/eq-2048/67e61b9a5877d64d08c56241.jpg',
    },
    sceneType: 'GROUND',
    _id: '67e61b9b5877d64d08c56247',
    groupId: 'welcome',
  },
  {
    id: 'pantry',
    title: 'Pantry',
    friendlyName: 'pantry',
    type: 'Ground',
    panoType: 'Image360',
    isDefault: false,
    location: '',
    viewingAngle: null,
    defaultOrientation: [8.670398032903078, -21.59916496075184, 500],
    coordinates: [0, 0, 0],
    lensFlareLocation: [],
    noLensFlare: true,
    showOnMap: false,
    yaw: 0,
    pitch: 0,
    roll: 0,
    elevation: null,
    previewImgUrl:
      'https://platform-resources-production.s3.ap-southeast-1.amazonaws.com/thumb/cae63735-b9a0-4dbf-b2f1-cf922ada4e9c.jpg',
    tourGroupId: '67e61b695877d64d08c56203',
    hotspots: [
      {
        id: 'pantry-54a984fc',
        type: 'Media',
        distance: '0',
        location: [-145.14767749011105, 32.799129763884444, 499.99999999999994],
        mediaLinkId: '67e63c985877d64d08c56942',
        tourLinkedId: null,
        sceneLinkId: null,
        sceneVariantId: null,
        icon: null,
        iconUrl: null,
        iconActiveUrl: null,
        polygon: [],
        configs: '',
        media: {
          id: 'pantry-54a984fc',
          friendlyName: 'pantry-54a984fc',
          imageUrl: null,
          readMoreUrl: null,
          text: null,
          title: 'Pantry',
          type: 'InfoTag',
          youtubeId: null,
          soundUrl: null,
          customData: null,
          infoTag: {
            text: 'Khu vực pantry là nơi nhân viên có thể thư giãn, thưởng thức đồ ăn và đồ uống nhẹ trong giờ làm việc. Đây cũng là không gian để mọi người trò chuyện, giao lưu và kết nối với nhau, giúp tạo thêm sự gắn',
            readMoreUrl: '',
          },
          fileUrl: null,
          configs: [],
          gallery: [],
          matterport: null,
          google360: null,
          mapFloorPlan: [],
          _id: '67e63c985877d64d08c56942',
        },
        _id: '67e63c985877d64d08c56942',
        friendlyName: 'pantry-54a984fc',
      },
      {
        media: {
          type: 'gift',
          _id: 'abc',
          imgUrl: '/assets/images/gift/2.png',
        },
        type: 'gift',
        location: [-87.86870507710772, -29.555509126569103, 500.00000000000006],
        _id: 'abc',
      },
      {
        media: {
          type: 'gift',
          _id: 'abc',
          imgUrl: '/assets/images/gift/1.png',
        },
        type: 'gift',
        location: [421.89787873756615, -45.8847934913262, -500.00000000000006],
        _id: 'abc',
      },
    ],
    mediaLogoOverride: null,
    variantTitle: null,
    variantOrder: 0,
    sceneVariants: null,
    sourceImgId: '67e61b9d5877d64d08c5624c',
    steps: [
      {
        id: '67e6231c5877d64d08c56540',
        updatedAt: '2025-03-28T04:18:36.812Z',
        isDeleted: false,
        deletedAt: null,
        sceneId: '67e61b9e5877d64d08c56252',
        targetSceneId: '67e61b9b5877d64d08c56247',
        stepPosition: [
          500.0000000000001, -165.1153616255488, -10.157407498972674,
        ],
        cameraPosition: [500, 16.93656189277973, -10.15740750804259],
        cameraRotation: [
          -9.992208713968552, -0.33846732265940144, 0.20298987162638293,
        ],
        targetSceneCameraPosition: [
          359.1495763235874, 33.37796563890552, -500.00000000000006,
        ],
        targetSceneCameraRotation: [
          -5.825389806984417, -0.541389085854219, 8.109977278291224,
        ],
        tourId: '67e61b695877d64d08c56201',
        createdAt: '2025-03-28T04:18:36.812Z',
        v: 0,
      },
    ],
    configuration: '',
    cubeMapImages: {
      size4096: [
        'https://platform-resources-production.s3.ap-southeast-1.amazonaws.com/4096-px/67e61b9d5877d64d08c5624c.jpg',
        'https://platform-resources-production.s3.ap-southeast-1.amazonaws.com/4096-nx/67e61b9d5877d64d08c5624c.jpg',
        'https://platform-resources-production.s3.ap-southeast-1.amazonaws.com/4096-py/67e61b9d5877d64d08c5624c.jpg',
        'https://platform-resources-production.s3.ap-southeast-1.amazonaws.com/4096-ny/67e61b9d5877d64d08c5624c.jpg',
        'https://platform-resources-production.s3.ap-southeast-1.amazonaws.com/4096-pz/67e61b9d5877d64d08c5624c.jpg',
        'https://platform-resources-production.s3.ap-southeast-1.amazonaws.com/4096-nz/67e61b9d5877d64d08c5624c.jpg',
      ],
      size2048: [
        'https://platform-resources-production.s3.ap-southeast-1.amazonaws.com/2048-px/67e61b9d5877d64d08c5624c.jpg',
        'https://platform-resources-production.s3.ap-southeast-1.amazonaws.com/2048-nx/67e61b9d5877d64d08c5624c.jpg',
        'https://platform-resources-production.s3.ap-southeast-1.amazonaws.com/2048-py/67e61b9d5877d64d08c5624c.jpg',
        'https://platform-resources-production.s3.ap-southeast-1.amazonaws.com/2048-ny/67e61b9d5877d64d08c5624c.jpg',
        'https://platform-resources-production.s3.ap-southeast-1.amazonaws.com/2048-pz/67e61b9d5877d64d08c5624c.jpg',
        'https://platform-resources-production.s3.ap-southeast-1.amazonaws.com/2048-nz/67e61b9d5877d64d08c5624c.jpg',
      ],
      size1024: [
        'https://platform-resources-production.s3.ap-southeast-1.amazonaws.com/1024-px/67e61b9d5877d64d08c5624c.jpg',
        'https://platform-resources-production.s3.ap-southeast-1.amazonaws.com/1024-nx/67e61b9d5877d64d08c5624c.jpg',
        'https://platform-resources-production.s3.ap-southeast-1.amazonaws.com/1024-py/67e61b9d5877d64d08c5624c.jpg',
        'https://platform-resources-production.s3.ap-southeast-1.amazonaws.com/1024-ny/67e61b9d5877d64d08c5624c.jpg',
        'https://platform-resources-production.s3.ap-southeast-1.amazonaws.com/1024-pz/67e61b9d5877d64d08c5624c.jpg',
        'https://platform-resources-production.s3.ap-southeast-1.amazonaws.com/1024-nz/67e61b9d5877d64d08c5624c.jpg',
      ],
    },
    sphericalImages: {
      resize4096:
        'https://platform-resources-production.s3.ap-southeast-1.amazonaws.com/eq-4096/67e61b9d5877d64d08c5624c.jpg',
      resize2048:
        'https://platform-resources-production.s3.ap-southeast-1.amazonaws.com/eq-2048/67e61b9d5877d64d08c5624c.jpg',
    },
    sceneType: 'GROUND',
    _id: '67e61b9e5877d64d08c56252',
    groupId: 'welcome',
  },
  {
    id: 'hr-mj-design-team',
    title: 'HR & Design Team',
    friendlyName: 'hr-mj-design-team',
    type: 'Ground',
    panoType: 'Image360',
    isDefault: false,
    location: '',
    viewingAngle: null,
    defaultOrientation: [
      97.6854934602718, -65.65148693349342, -500.00000000000006,
    ],
    coordinates: [0, 0, 0],
    lensFlareLocation: [],
    noLensFlare: true,
    showOnMap: false,
    yaw: 0,
    pitch: 0,
    roll: 0,
    elevation: null,
    previewImgUrl:
      'https://platform-resources-production.s3.ap-southeast-1.amazonaws.com/thumb/55ff65ea-cf16-485a-8e46-fa06481528db.jpg',
    tourGroupId: '67e61b695877d64d08c56203',
    hotspots: [
      {
        id: 'accounting-room-047733c2',
        type: 'Media',
        distance: '0',
        location: [500, 10.862166928464509, -45.34899397976409],
        mediaLinkId: '67e63c545877d64d08c56918',
        tourLinkedId: null,
        sceneLinkId: null,
        sceneVariantId: null,
        icon: null,
        iconUrl: null,
        iconActiveUrl: null,
        polygon: [],
        configs: '',
        media: {
          id: 'accounting-room-047733c2',
          friendlyName: 'accounting-room-047733c2',
          imageUrl: null,
          readMoreUrl: null,
          text: null,
          title: 'Accounting Room',
          type: 'InfoTag',
          youtubeId: null,
          soundUrl: null,
          customData: null,
          infoTag: {
            text: 'Đây là phòng kế toán, nơi thực hiện các hoạt động quản lý tài chính, lập báo cáo, kiểm toán và xử lý các giao dịch tài chính của công ty.',
            readMoreUrl: '',
          },
          fileUrl: null,
          configs: [],
          gallery: [],
          matterport: null,
          google360: null,
          mapFloorPlan: [],
          _id: '67e63c545877d64d08c56918',
        },
        _id: '67e63c545877d64d08c56918',
        friendlyName: 'accounting-room-047733c2',
      },
      {
        id: 'hr-az-design-team-f1b9cfeb',
        type: 'Media',
        distance: '0',
        location: [15.506373235995811, -1.329878503607965, -499.99999999999994],
        mediaLinkId: '67e63c795877d64d08c56922',
        tourLinkedId: null,
        sceneLinkId: null,
        sceneVariantId: null,
        icon: null,
        iconUrl: null,
        iconActiveUrl: null,
        polygon: [],
        configs: '',
        media: {
          id: 'hr-az-design-team-f1b9cfeb',
          friendlyName: 'hr-az-design-team-f1b9cfeb',
          imageUrl: null,
          readMoreUrl: null,
          text: null,
          title: 'HR & Design Team',
          type: 'InfoTag',
          youtubeId: null,
          soundUrl: null,
          customData: null,
          infoTag: {
            text: 'Đây là khu vực của nhóm thiết kế và quản lý nhân sự',
            readMoreUrl: '',
          },
          fileUrl: null,
          configs: [],
          gallery: [],
          matterport: null,
          google360: null,
          mapFloorPlan: [],
          _id: '67e63c795877d64d08c56922',
        },
        _id: '67e63c795877d64d08c56922',
        friendlyName: 'hr-az-design-team-f1b9cfeb',
      },
      {
        media: {
          type: 'gift',
          _id: 'abc',
          imgUrl: '/assets/images/gift/1.png',
        },
        type: 'gift',
        location: [-2.7326205232281966, -106.4075820030512, 500],
        _id: 'abc',
      },
      {
        media: {
          type: 'gift',
          _id: 'abc',
          imgUrl: '/assets/images/gift/2.png',
        },
        type: 'gift',
        location: [
          -461.37413035385043, -27.253616855643116, -500.00000000000006,
        ],
        _id: 'abc',
      },
    ],
    mediaLogoOverride: null,
    variantTitle: null,
    variantOrder: 0,
    sceneVariants: null,
    sourceImgId: '67e61ba15877d64d08c56258',
    steps: [
      {
        id: '67e6231c5877d64d08c56544',
        updatedAt: '2025-03-28T04:18:36.816Z',
        isDeleted: false,
        deletedAt: null,
        sceneId: '67e61ba25877d64d08c5625e',
        targetSceneId: '67e61b9b5877d64d08c56247',
        stepPosition: [-500, -206.5881491513327, -88.9393838914306],
        cameraPosition: [-500, -17.198957378322962, -88.93938388178286],
        cameraRotation: [
          9.839812527767217, 0.3384690325515135, 1.7502937274637302,
        ],
        targetSceneCameraPosition: [
          500.0000000000001, 51.95473123251865, 396.3686153482852,
        ],
        targetSceneCameraRotation: [
          -7.810523084434038, -0.8115872552743058, -6.191692440245879,
        ],
        tourId: '67e61b695877d64d08c56201',
        createdAt: '2025-03-28T04:18:36.816Z',
        v: 0,
      },
      {
        id: '67e6235e5877d64d08c565da',
        updatedAt: '2025-03-28T04:19:42.013Z',
        isDeleted: false,
        deletedAt: null,
        sceneId: '67e61ba25877d64d08c5625e',
        targetSceneId: '67e61ba55877d64d08c56269',
        stepPosition: [
          -85.45107987971944, -198.40610910287276, 500.00000000000006,
        ],
        cameraPosition: [-85.45107987971929, -10.304676592512259, 500],
        cameraRotation: [
          1.6842496795453894, 0.20310624831409252, -9.855052048002968,
        ],
        targetSceneCameraPosition: [
          -13.544657312346276, -16.939365977025144, -500.00000000000006,
        ],
        targetSceneCameraRotation: [
          0.270638649139972, 0.3384690376131454, 9.990605258550106,
        ],
        tourId: '67e61b695877d64d08c56201',
        createdAt: '2025-03-28T04:19:42.013Z',
        v: 0,
      },
    ],
    configuration: '',
    cubeMapImages: {
      size4096: [
        'https://platform-resources-production.s3.ap-southeast-1.amazonaws.com/4096-px/67e61ba15877d64d08c56258.jpg',
        'https://platform-resources-production.s3.ap-southeast-1.amazonaws.com/4096-nx/67e61ba15877d64d08c56258.jpg',
        'https://platform-resources-production.s3.ap-southeast-1.amazonaws.com/4096-py/67e61ba15877d64d08c56258.jpg',
        'https://platform-resources-production.s3.ap-southeast-1.amazonaws.com/4096-ny/67e61ba15877d64d08c56258.jpg',
        'https://platform-resources-production.s3.ap-southeast-1.amazonaws.com/4096-pz/67e61ba15877d64d08c56258.jpg',
        'https://platform-resources-production.s3.ap-southeast-1.amazonaws.com/4096-nz/67e61ba15877d64d08c56258.jpg',
      ],
      size2048: [
        'https://platform-resources-production.s3.ap-southeast-1.amazonaws.com/2048-px/67e61ba15877d64d08c56258.jpg',
        'https://platform-resources-production.s3.ap-southeast-1.amazonaws.com/2048-nx/67e61ba15877d64d08c56258.jpg',
        'https://platform-resources-production.s3.ap-southeast-1.amazonaws.com/2048-py/67e61ba15877d64d08c56258.jpg',
        'https://platform-resources-production.s3.ap-southeast-1.amazonaws.com/2048-ny/67e61ba15877d64d08c56258.jpg',
        'https://platform-resources-production.s3.ap-southeast-1.amazonaws.com/2048-pz/67e61ba15877d64d08c56258.jpg',
        'https://platform-resources-production.s3.ap-southeast-1.amazonaws.com/2048-nz/67e61ba15877d64d08c56258.jpg',
      ],
      size1024: [
        'https://platform-resources-production.s3.ap-southeast-1.amazonaws.com/1024-px/67e61ba15877d64d08c56258.jpg',
        'https://platform-resources-production.s3.ap-southeast-1.amazonaws.com/1024-nx/67e61ba15877d64d08c56258.jpg',
        'https://platform-resources-production.s3.ap-southeast-1.amazonaws.com/1024-py/67e61ba15877d64d08c56258.jpg',
        'https://platform-resources-production.s3.ap-southeast-1.amazonaws.com/1024-ny/67e61ba15877d64d08c56258.jpg',
        'https://platform-resources-production.s3.ap-southeast-1.amazonaws.com/1024-pz/67e61ba15877d64d08c56258.jpg',
        'https://platform-resources-production.s3.ap-southeast-1.amazonaws.com/1024-nz/67e61ba15877d64d08c56258.jpg',
      ],
    },
    sphericalImages: {
      resize4096:
        'https://platform-resources-production.s3.ap-southeast-1.amazonaws.com/eq-4096/67e61ba15877d64d08c56258.jpg',
      resize2048:
        'https://platform-resources-production.s3.ap-southeast-1.amazonaws.com/eq-2048/67e61ba15877d64d08c56258.jpg',
    },
    sceneType: 'GROUND',
    _id: '67e61ba25877d64d08c5625e',
    groupId: 'welcome',
  },
  {
    id: 'right-passage',
    title: 'Right Passage',
    friendlyName: 'right-passage',
    type: 'Ground',
    panoType: 'Image360',
    isDefault: false,
    location: '',
    viewingAngle: null,
    defaultOrientation: [
      4.740010711753179, -78.85395162287514, 500.00000000000006,
    ],
    coordinates: [0, 0, 0],
    lensFlareLocation: [],
    noLensFlare: true,
    showOnMap: false,
    yaw: 0,
    pitch: 0,
    roll: 0,
    elevation: null,
    previewImgUrl:
      'https://platform-resources-production.s3.ap-southeast-1.amazonaws.com/thumb/ac8ebcc9-6176-40ba-8ba4-f5dba636f88f.jpg',
    tourGroupId: '67e61b695877d64d08c56203',
    hotspots: [
      {
        media: {
          type: 'gift',
          _id: 'abc',
          imgUrl: '/assets/images/gift/3.png',
        },
        type: 'gift',
        location: [2.0944497443663215, -97.13947572037043, -500],
        _id: 'abc',
      },
      {
        media: {
          type: 'gift',
          _id: 'abc',
          imgUrl: '/assets/images/gift/1.png',
        },
        type: 'gift',
        location: [2.0944497443663215, -97.13947572037043, -500],
        _id: 'abc',
      },
    ],
    mediaLogoOverride: null,
    variantTitle: null,
    variantOrder: 0,
    sceneVariants: null,
    sourceImgId: '67e61ba55877d64d08c56263',
    steps: [
      {
        id: '67e6225e5877d64d08c56471',
        updatedAt: '2025-03-28T04:15:26.402Z',
        isDeleted: false,
        deletedAt: null,
        sceneId: '67e61ba55877d64d08c56269',
        targetSceneId: '67e61b8e5877d64d08c5621b',
        stepPosition: [
          6.770829962441404, -239.83274325572017, -499.99999999999994,
        ],
        cameraPosition: [
          6.770842849049284, -47.54157856194844, -500.00000000000006,
        ],
        cameraRotation: [
          -0.13479658978756098, 0.9464763554758758, 9.954195717781872,
        ],
        targetSceneCameraPosition: [
          -430.5654632622769, -8.935646356615987, 500,
        ],
        targetSceneCameraRotation: [
          6.52471931499264, 0.13540933806723174, -7.57691904217843,
        ],
        tourId: '67e61b695877d64d08c56201',
        createdAt: '2025-03-28T04:15:26.402Z',
        v: 0,
      },
      {
        id: '67e6235e5877d64d08c565dc',
        updatedAt: '2025-03-28T04:19:42.021Z',
        isDeleted: false,
        deletedAt: null,
        sceneId: '67e61ba55877d64d08c56269',
        targetSceneId: '67e61ba25877d64d08c5625e',
        stepPosition: [13.544657205035472, -203.52519016318735, 500],
        cameraPosition: [
          13.544657312346276, -16.939365977025144, 500.00000000000006,
        ],
        cameraRotation: [
          -0.270638649139972, 0.3384690376131454, -9.990605258550106,
        ],
        targetSceneCameraPosition: [
          85.45107987971929, -10.304676592512259, -500,
        ],
        targetSceneCameraRotation: [
          -1.6842496795453894, 0.20310624831409252, 9.855052048002968,
        ],
        tourId: '67e61b695877d64d08c56201',
        createdAt: '2025-03-28T04:19:42.021Z',
        v: 0,
      },
    ],
    configuration: '',
    cubeMapImages: {
      size4096: [
        'https://platform-resources-production.s3.ap-southeast-1.amazonaws.com/4096-px/67e61ba55877d64d08c56263.jpg',
        'https://platform-resources-production.s3.ap-southeast-1.amazonaws.com/4096-nx/67e61ba55877d64d08c56263.jpg',
        'https://platform-resources-production.s3.ap-southeast-1.amazonaws.com/4096-py/67e61ba55877d64d08c56263.jpg',
        'https://platform-resources-production.s3.ap-southeast-1.amazonaws.com/4096-ny/67e61ba55877d64d08c56263.jpg',
        'https://platform-resources-production.s3.ap-southeast-1.amazonaws.com/4096-pz/67e61ba55877d64d08c56263.jpg',
        'https://platform-resources-production.s3.ap-southeast-1.amazonaws.com/4096-nz/67e61ba55877d64d08c56263.jpg',
      ],
      size2048: [
        'https://platform-resources-production.s3.ap-southeast-1.amazonaws.com/2048-px/67e61ba55877d64d08c56263.jpg',
        'https://platform-resources-production.s3.ap-southeast-1.amazonaws.com/2048-nx/67e61ba55877d64d08c56263.jpg',
        'https://platform-resources-production.s3.ap-southeast-1.amazonaws.com/2048-py/67e61ba55877d64d08c56263.jpg',
        'https://platform-resources-production.s3.ap-southeast-1.amazonaws.com/2048-ny/67e61ba55877d64d08c56263.jpg',
        'https://platform-resources-production.s3.ap-southeast-1.amazonaws.com/2048-pz/67e61ba55877d64d08c56263.jpg',
        'https://platform-resources-production.s3.ap-southeast-1.amazonaws.com/2048-nz/67e61ba55877d64d08c56263.jpg',
      ],
      size1024: [
        'https://platform-resources-production.s3.ap-southeast-1.amazonaws.com/1024-px/67e61ba55877d64d08c56263.jpg',
        'https://platform-resources-production.s3.ap-southeast-1.amazonaws.com/1024-nx/67e61ba55877d64d08c56263.jpg',
        'https://platform-resources-production.s3.ap-southeast-1.amazonaws.com/1024-py/67e61ba55877d64d08c56263.jpg',
        'https://platform-resources-production.s3.ap-southeast-1.amazonaws.com/1024-ny/67e61ba55877d64d08c56263.jpg',
        'https://platform-resources-production.s3.ap-southeast-1.amazonaws.com/1024-pz/67e61ba55877d64d08c56263.jpg',
        'https://platform-resources-production.s3.ap-southeast-1.amazonaws.com/1024-nz/67e61ba55877d64d08c56263.jpg',
      ],
    },
    sphericalImages: {
      resize4096:
        'https://platform-resources-production.s3.ap-southeast-1.amazonaws.com/eq-4096/67e61ba55877d64d08c56263.jpg',
      resize2048:
        'https://platform-resources-production.s3.ap-southeast-1.amazonaws.com/eq-2048/67e61ba55877d64d08c56263.jpg',
    },
    sceneType: 'GROUND',
    _id: '67e61ba55877d64d08c56269',
    groupId: 'welcome',
  },
];
